import React from 'react'

function Loader() {
  return (
    <div className="loading-container position-fixed min-vh-100 min-vw-100">
      <div className="loading-display">
      <div className="loading-display-gif">
        <img alt="manpower-manpower-loader" src={process.env.PUBLIC_URL + '/assets/images/loading.gif'} />
      </div>
      <div className="loading-display-text">Loading...</div>
      </div>
    </div>
  )
}

export default Loader